import React from 'react';

import ResultsPerPageContainer from './ResultsPerPage';
import PaginationContainer from './Pagination';

export default class ResultsPagination extends React.PureComponent {
  render() {
    return (
      <nav className="e2e-results-pagination rx-list els-pagination-wrapper" aria-label="Page navigation">
        <ResultsPerPageContainer />
        <PaginationContainer />
      </nav>
    );
  }
}
